/**
 * @generated SignedSource<<f90102d0468c59b035221f0dc8f52cc8>>
 * @relayHash 4d004a73489838d33188a94fe46f7a68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0fdb5ed7fac8b16ffe8e33641a06a6fd184962a01086f4e913a21834680bd1e2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0fdb5ed7fac8b16ffe8e33641a06a6fd184962a01086f4e913a21834680bd1e2",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
